function articlesReady() {

    $('.submit-on-change').on("change", function (e) {
        $(this).parents('form').submit();
    });
}

$(document).ready(articlesReady);
